import { useState, useCallback, useMemo, createContext, useContext } from 'react';

/**
 * CAA (Comunicazione Aumentativa Alternativa) Dictionary
 * Extended mapping of Italian primary school words to Emojis
 */
const CAA_DICTIONARY = {
  // Saluti e Pronomi
  'ciao': '👋',
  'buongiorno': '🌅',
  'buonasera': '🌆',
  'arrivederci': '👋',
  'grazie': '🙏',
  'prego': '🤝',
  'sì': '✅',
  'no': '❌',
  'io': '🧑',
  'tu': '👉',
  'lui': '👨',
  'lei': '👩',
  'noi': '👥',
  'voi': '👥',
  'loro': '👥',
  
  // Famiglia
  'mamma': '👩',
  'papà': '👨',
  'papa': '👨',
  'bambino': '👦',
  'bambina': '👧',
  'fratello': '👦',
  'sorella': '👧',
  'nonno': '👴',
  'nonna': '👵',
  'famiglia': '👨‍👩‍👧‍👦',
  'amico': '🤝',
  'amica': '🤝',
  
  // Scuola
  'scuola': '🏫',
  'classe': '🏫',
  'maestro': '👨‍🏫',
  'maestra': '👩‍🏫',
  'studente': '🧑‍🎓',
  'libro': '📖',
  'quaderno': '📓',
  'penna': '🖊️',
  'matita': '✏️',
  'gomma': '🧽',
  'zaino': '🎒',
  'banco': '🪑',
  'lavagna': '📋',
  'compito': '📝',
  'lezione': '📚',
  'ricreazione': '⏰',
  
  // Casa e Luoghi
  'casa': '🏠',
  'camera': '🛏️',
  'cucina': '🍳',
  'bagno': '🚿',
  'giardino': '🌳',
  'parco': '🌲',
  'strada': '🛣️',
  'città': '🏙️',
  'paese': '🏘️',
  'mare': '🌊',
  'montagna': '⛰️',
  'fiume': '🏞️',
  'lago': '💧',
  'bosco': '🌲',
  
  // Animali
  'cane': '🐶',
  'gatto': '🐱',
  'uccello': '🐦',
  'pesce': '🐟',
  'farfalla': '🦋',
  'ape': '🐝',
  'cavallo': '🐴',
  'mucca': '🐄',
  'maiale': '🐷',
  'gallina': '🐔',
  'coniglio': '🐰',
  'leone': '🦁',
  'elefante': '🐘',
  'orso': '🐻',
  'topo': '🐭',
  'rana': '🐸',
  'tartaruga': '🐢',
  'serpente': '🐍',
  'delfino': '🐬',
  'balena': '🐋',
  
  // Cibo
  'mela': '🍎',
  'pera': '🍐',
  'banana': '🍌',
  'arancia': '🍊',
  'fragola': '🍓',
  'uva': '🍇',
  'anguria': '🍉',
  'ciliegia': '🍒',
  'pane': '🍞',
  'pizza': '🍕',
  'pasta': '🍝',
  'riso': '🍚',
  'latte': '🥛',
  'acqua': '💧',
  'gelato': '🍦',
  'torta': '🎂',
  'biscotto': '🍪',
  'cioccolato': '🍫',
  'formaggio': '🧀',
  'uovo': '🥚',
  'carota': '🥕',
  'pomodoro': '🍅',
  'insalata': '🥗',
  
  // Natura e Tempo
  'sole': '☀️',
  'luna': '🌙',
  'stella': '⭐',
  'nuvola': '☁️',
  'pioggia': '🌧️',
  'neve': '❄️',
  'vento': '💨',
  'arcobaleno': '🌈',
  'fiore': '🌸',
  'albero': '🌳',
  'foglia': '🍃',
  'erba': '🌿',
  'cielo': '🌤️',
  'terra': '🌍',
  
  // Emozioni
  'felice': '😊',
  'contento': '😄',
  'triste': '😢',
  'arrabbiato': '😠',
  'spaventato': '😨',
  'sorpreso': '😮',
  'stanco': '😴',
  'amore': '❤️',
  'cuore': '❤️',
  'bello': '✨',
  'brutto': '👎',
  
  // Azioni comuni
  'mangiare': '🍽️',
  'bere': '🥤',
  'dormire': '😴',
  'giocare': '🎮',
  'leggere': '📖',
  'scrivere': '✍️',
  'correre': '🏃',
  'camminare': '🚶',
  'saltare': '🦘',
  'nuotare': '🏊',
  'cantare': '🎤',
  'ballare': '💃',
  'disegnare': '🎨',
  'parlare': '🗣️',
  'ascoltare': '👂',
  'guardare': '👀',
  'pensare': '💭',
  'aiutare': '🤝',
  'lavorare': '💼',
  
  // Oggetti comuni
  'telefono': '📱',
  'computer': '💻',
  'televisione': '📺',
  'orologio': '⏰',
  'chiave': '🔑',
  'porta': '🚪',
  'finestra': '🪟',
  'letto': '🛏️',
  'tavolo': '🪑',
  'sedia': '🪑',
  'macchina': '🚗',
  'bicicletta': '🚲',
  'treno': '🚂',
  'aereo': '✈️',
  'barca': '⛵',
  
  // Numeri
  'uno': '1️⃣',
  'due': '2️⃣',
  'tre': '3️⃣',
  'quattro': '4️⃣',
  'cinque': '5️⃣',
  'sei': '6️⃣',
  'sette': '7️⃣',
  'otto': '8️⃣',
  'nove': '9️⃣',
  'dieci': '🔟',
  
  // Colori
  'rosso': '🔴',
  'blu': '🔵',
  'verde': '🟢',
  'giallo': '🟡',
  'arancione': '🟠',
  'viola': '🟣',
  'nero': '⚫',
  'bianco': '⚪',
  'rosa': '🩷',
  'marrone': '🟤',
  
  // Tempo
  'oggi': '📅',
  'domani': '📆',
  'ieri': '📆',
  'mattina': '🌅',
  'pomeriggio': '🌤️',
  'sera': '🌆',
  'notte': '🌙',
  'settimana': '📅',
  'mese': '📆',
  'anno': '📆',
  
  // Corpo
  'testa': '🧠',
  'mano': '✋',
  'piede': '🦶',
  'occhio': '👁️',
  'bocca': '👄',
  'naso': '👃',
  'orecchio': '👂',
  'capelli': '💇',
  'dente': '🦷',
  
  // Verbi ausiliari e connettivi
  'è': '=',
  'sono': '=',
  'ha': '✓',
  'hanno': '✓',
  'fa': '⚡',
  'va': '➡️',
  'viene': '⬅️',
  'e': '➕',
  'con': '🤝',
  'per': '➡️',
  'in': '📍',
  'su': '⬆️',
  'giù': '⬇️',
  'grande': '📏',
  'piccolo': '🔹',
  'molto': '➕➕',
  'poco': '➖',
  'tutto': '💯',
  'niente': '0️⃣',
};

/**
 * Transform a single word to CAA format
 * @param {string} word - The word to transform
 * @returns {object} - { original, symbol, hasSymbol }
 */
const transformWord = (word) => {
  const cleanWord = word.toLowerCase().replace(/[.,!?;:'"()«»\-]/g, '').trim();
  const symbol = CAA_DICTIONARY[cleanWord];
  
  return {
    original: word,
    cleanWord,
    symbol: symbol || null,
    hasSymbol: !!symbol
  };
};

/**
 * Transform entire text to CAA format
 * @param {string} text - The text to transform
 * @returns {Array} - Array of word objects with symbols
 */
export const textToSymbols = (text) => {
  if (!text) return [];
  
  // Split text preserving punctuation and whitespace
  const tokens = text.split(/(\s+|[.,!?;:'"()«»\-]+)/);
  
  return tokens.map((token, index) => {
    // Check if it's whitespace or punctuation only
    if (/^[\s.,!?;:'"()«»\-]+$/.test(token)) {
      return {
        type: 'separator',
        content: token,
        index
      };
    }
    
    const transformed = transformWord(token);
    return {
      type: transformed.hasSymbol ? 'symbol' : 'word',
      content: token,
      symbol: transformed.symbol,
      cleanWord: transformed.cleanWord,
      index
    };
  });
};

/**
 * Get statistics about CAA coverage for a text
 * @param {string} text - The text to analyze
 * @returns {object} - Statistics object
 */
export const getCAAStats = (text) => {
  const tokens = textToSymbols(text);
  const words = tokens.filter(t => t.type !== 'separator');
  const symbolized = words.filter(t => t.type === 'symbol');
  
  return {
    totalWords: words.length,
    symbolizedWords: symbolized.length,
    coverage: words.length > 0 ? (symbolized.length / words.length * 100).toFixed(1) : 0,
    uniqueSymbols: [...new Set(symbolized.map(s => s.symbol))].length
  };
};

/**
 * Get all available CAA words by category
 */
export const getCAACategories = () => ({
  'Saluti': ['ciao', 'buongiorno', 'grazie', 'sì', 'no'],
  'Pronomi': ['io', 'tu', 'lui', 'lei', 'noi'],
  'Famiglia': ['mamma', 'papà', 'bambino', 'fratello', 'sorella', 'nonno', 'nonna'],
  'Scuola': ['scuola', 'libro', 'quaderno', 'penna', 'matita', 'zaino', 'maestra'],
  'Casa': ['casa', 'camera', 'cucina', 'bagno', 'giardino'],
  'Animali': ['cane', 'gatto', 'uccello', 'pesce', 'cavallo', 'leone'],
  'Cibo': ['mela', 'pane', 'pizza', 'pasta', 'latte', 'acqua', 'gelato'],
  'Natura': ['sole', 'luna', 'stella', 'fiore', 'albero', 'mare'],
  'Emozioni': ['felice', 'triste', 'arrabbiato', 'amore'],
  'Azioni': ['mangiare', 'bere', 'dormire', 'giocare', 'leggere', 'scrivere'],
  'Colori': ['rosso', 'blu', 'verde', 'giallo', 'arancione'],
  'Numeri': ['uno', 'due', 'tre', 'quattro', 'cinque']
});

/**
 * CAA Dictionary export for reference
 */
export const CAA_WORDS = CAA_DICTIONARY;

// ============================================
// CAA CONTEXT & HOOK
// ============================================

const CAAContext = createContext(null);

/**
 * CAA Provider Component
 * Provides global CAA state management
 */
export const CAAProvider = ({ children }) => {
  const [isEnabled, setIsEnabled] = useState(() => {
    const saved = localStorage.getItem('caa_enabled');
    return saved === 'true';
  });
  
  const [showWordBelow, setShowWordBelow] = useState(true);
  const [symbolSize, setSymbolSize] = useState('large'); // 'small', 'medium', 'large'
  
  // Persist settings
  const toggleCAA = useCallback(() => {
    setIsEnabled(prev => {
      const newValue = !prev;
      localStorage.setItem('caa_enabled', newValue.toString());
      return newValue;
    });
  }, []);
  
  const enableCAA = useCallback(() => {
    setIsEnabled(true);
    localStorage.setItem('caa_enabled', 'true');
  }, []);
  
  const disableCAA = useCallback(() => {
    setIsEnabled(false);
    localStorage.setItem('caa_enabled', 'false');
  }, []);

  const value = useMemo(() => ({
    isEnabled,
    showWordBelow,
    symbolSize,
    toggleCAA,
    enableCAA,
    disableCAA,
    setShowWordBelow,
    setSymbolSize,
    textToSymbols,
    getCAAStats,
    CAA_WORDS
  }), [isEnabled, showWordBelow, symbolSize, toggleCAA, enableCAA, disableCAA]);

  return (
    <CAAContext.Provider value={value}>
      {children}
    </CAAContext.Provider>
  );
};

/**
 * useCAA Hook
 * Access CAA functionality and state
 */
export const useCAA = () => {
  const context = useContext(CAAContext);
  
  // If not in provider, return standalone functions
  if (!context) {
    return {
      isEnabled: false,
      showWordBelow: true,
      symbolSize: 'large',
      toggleCAA: () => console.warn('CAAProvider not found'),
      enableCAA: () => console.warn('CAAProvider not found'),
      disableCAA: () => console.warn('CAAProvider not found'),
      textToSymbols,
      getCAAStats,
      CAA_WORDS
    };
  }
  
  return context;
};

export default useCAA;
